import { render, staticRenderFns } from "./RiskNodeAppender.vue?vue&type=template&id=36950e02&scoped=true"
import script from "./RiskNodeAppender.vue?vue&type=script&lang=js"
export * from "./RiskNodeAppender.vue?vue&type=script&lang=js"
import style0 from "./RiskNodeAppender.vue?vue&type=style&index=0&id=36950e02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36950e02",
  null
  
)

export default component.exports